import { graphqlApolloClient as client } from "../graphql-apollo-client"
import { BLOCK_BENEFICIARIES_F21 } from "./graphql/mutations/block-beneficiaries-f21-mutation"

/**
 * @param {{
 * beneficiaryData: object,
 * expectedChangeData: object,
 * requiredActivitiesData: object,
 * generalObjectiveIndicatorsRelationship: object
 * }[]} data
 */
export const BlockBeneficiariesF21 = async (data = []) => {
  const result = await client.mutate({
    mutation: BLOCK_BENEFICIARIES_F21,
    variables: {
      data
    }
  })

  return result.data?.beneficiaries || []
}